import "./src/styles/global.scss";
import '@fortawesome/fontawesome-svg-core/styles.css'